import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/MyCoursesPage.css"; // özel stil dosyası

const colors = [
    '#a594ef', '#f3c6de', '#cec4f8', '#7a8ded', '#33FFF5',
    '#f7f8de', 'rgba(213,134,239,0.95)', '#d9b6f4', 'rgba(233,144,236,0.5)', '#FF3380'
];

const MyCoursesPage = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/course-participants/courses/${localStorage.getItem("userEmail")}`)
            .then(res => res.json())
            .then(data => {
                setCourses(data);
                console.log(data);
                setLoading(false);
            })
            .catch(err => {
                setError("Kurslar yüklenemedi.");
                setLoading(false);
            });
    }, []);

    if (loading) return <p>Yükleniyor...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="my-courses-container">
            <h2>📚 Kayıtlı Olduğunuz Kurslar</h2>
            <div className="course-grid">
                {courses?.map((course, index) => (
                    <div
                        key={course.id}
                        className="course-card"
                        style={{ backgroundColor: colors[index % colors.length] }}
                    >
                        <img src="/images/mamografi_drawing.jpg" alt={course.name} />
                        <div className="course-details">
                            <small><i className="fa fa-calendar"></i> Başlangıç: {course.startDate}</small>
                            <small><i className="fa fa-clock"></i> Bitiş: {course.endDate}</small>
                        </div>
                        <h3>{course.name}</h3>
                        <div className="course-buttons">
                            <Link to={`/course-details/${course.id}`} className="course-button">
                                Detaylar
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyCoursesPage;
